import { TRestErrorHandler, RestApiResponse } from '@oceanjs/core';


import {  ApiKeycloakEnv, ApiEnvInfo, IGetUserResponse } from './AppEnvironment.types';
import { EhpcBaseRestApi } from '../EhpcBaseRestApi';
import { SpringRestConfig } from '../SpringRestConfig';
import { IOceanResponse } from '../dto';

const resource = SpringRestConfig.baseEndpoint;
/**
 * Api to access the application environment
 */
class AppEnvironmentApiImpl extends EhpcBaseRestApi {

  public getUserInfo(onError?: TRestErrorHandler): RestApiResponse<IGetUserResponse> {
    return this.getCustomEndpoint('auth/user', undefined, onError);
  }

  public getEnvInfo(onError?: TRestErrorHandler): RestApiResponse<ApiEnvInfo> {
    return this.getCustomEndpoint('env', undefined, onError);

  } 

  public getEnvKeycloak(onError?: TRestErrorHandler): RestApiResponse<IOceanResponse<ApiKeycloakEnv>> {
    return this.getCustomEndpoint('env/keycloak',undefined, onError);
  }

}

export const AppEnvironmentApi = new AppEnvironmentApiImpl(resource);
